export const getDestinationIcon = (code: string) => {
    switch (code) {
        case "Web Service":
        case "http":
            return "/assets/images/typeImages/lead/destinations/web-service.png";
        case "Zoho CRM":
        case "zoho":
            return "/assets/images/typeImages/lead/destinations/zoho.png";
        case "Salesforce":
        case "salesforce":
            return "/assets/images/typeImages/lead/destinations/salesforce.png";
        case "Microsoft Dynamics":
        case "microsoft-dynamics":
            return "/assets/images/typeImages/lead/destinations/microsoft-dynamics-logo.png";
        case "High Level":
        case "high-level":
            return "/assets/images/typeImages/lead/destinations/highlevel.png";
        case "Sugar CRM":
        case "sugar-crm":
            return "/assets/images/typeImages/lead/destinations/sugar.png";
        case "Odoo":
        case "odoo":
            return "/assets/images/typeImages/lead/destinations/odoo.png";
        case "Perfex":
        case "perfex":
            return "/assets/images/typeImages/lead/destinations/perfex.png";
        case "Fresh Sales":
        case "fresh-sales":
            return "/assets/images/typeImages/lead/destinations/freshsales-crm.png";
        case "Vtiger":
        case "vtiger":
            return "/assets/images/typeImages/lead/destinations/vtiger-crm.png";
        case "Wati":
        case "wati":
            return "/assets/images/typeImages/lead/destinations/wati.png";
        case "Monday":
        case "monday":
            return "/assets/images/typeImages/lead/destinations/monday.png";
        case "Hubspot":
        case "hubspot":
            return "/assets/images/typeImages/lead/destinations/hubspot-icon.png";
        case "Zendesk":
        case "zendesk":
            return "/assets/images/typeImages/lead/destinations/zendesk-icon.png";
        case "Bitrix 24":
        case "b24":
            return "/assets/images/typeImages/b24.png";
        case "Google BigQuery":
        case "bigquery":
            return "/assets/images/typeImages/bigquery.png";
        case "Google Sheets":
        case "google-sheets":
            return "/assets/images/typeImages/google-sheets-icon.png";
        default:
            return "";
    }
};

export const getSourceName = (code: string) => {
    switch (code) {
        case "fl":
        case "Facebook Lead":
            return "Facebook Lead";
        case "sapi":
        case "Source API":
            return "Source API";
        case "tiktok":
        case "Tiktok Lead Generation":
            return "Tiktok Lead Generation";
        case "gglw":
        case "Google Lead Form Webhook":
            return "Google Lead Form Webhook";
        case "lnkdn":
        case "Linkedin Lead Generation":
            return "Linkedin Lead Generation";
        default:
            return "";
    }
};

export const getSourceIcon = (code: string) => {
    switch (code) {
        case "fl":
        case "Facebook Lead":
        case "Facebook":
            return "/assets/images/typeImages/lead/sources/fb.png";
        case "sapi":
        case "Source API":
        case "Custom API":
            return "/assets/images/typeImages/lead/sources/sapi.png";
        case "tiktok":
        case "Tiktok Lead Generation":
        case "TikTok":
            return "/assets/images/typeImages/lead/sources/tt.png";
        case "gglw":
        case "Google Lead Form Webhook":
            return "/assets/images/google.png";
        case "lnkdn":
        case "Linkedin Lead Generation":
        case "LinkedIn":
            return "/assets/images/typeImages/lead/sources/linkedin.png";
        default:
            return "";
    }
};

export const getDestinationName = (code: string) => {
    switch (code) {
        case "http":
        case "Web Service":
            return "Web Service";
        case "zoho":
        case "Zoho CRM":
            return "Zoho CRM";
        case "salesforce":
        case "Salesforce":
            return "Salesforce";
        case "microsoft-dynamics":
        case "Microsoft Dynamics":
            return "Microsoft Dynamics";
        case "high-level":
        case "High Level":
            return "High Level";
        case "sugar-crm":
        case "Sugar CRM":
            return "Sugar CRM";
        case "odoo":
        case "Odoo":
            return "Odoo";
        case "perfex":
        case "Perfex":
            return "Perfex";
        case "fresh-sales":
        case "Fresh Sales":
            return "Fresh Sales";
        case "vtiger":
        case "Vtiger":
            return "Vtiger";
        case "wati":
        case "Wati":
            return "Wati";
        case "monday":
        case "Monday":
            return "Monday";
        case "hubspot":
        case "Hubspot":
            return "Hubspot";
        case "zendesk":
        case "Zendesk":
            return "Zendesk";
        case "b24":
        case "Bitrix 24":
            return "Bitrix 24";
        case "bigquery":
        case "Google BigQuery":
            return "Google BigQuery";
        case "google-sheets":
        case "Google Sheets":
            return "Google Sheets";
        default:
            return "";
    }
};
